import * as Yup from 'yup'


export const NewProjectManagerSchema = Yup.object().shape({
  first_name: Yup.string().required('First name is required.'),
  last_name: Yup.string().required('Last name is required.'),
  email: Yup.string()
    .required('Email is required.')
    .email('Enter a valid email address.')
    .matches(
      /^[\w-.]+@reachbird\.io$/,
      'Registration is only available with an @reachbird.io email address.'
    ),
  password: Yup.string()
    .required('Password is required.')
    .min(12, 'Password must be at least 12 characters.')
    .test({
      name: 'passwordComplexity',
      test: (password) =>
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&_])[^\s]{12,}$/.test(password),
      message:
        'Password must include uppercase, lowercase, a number, and a special character (#@$!%*?&_).',
    }),
  password_confirmation: Yup.string()
    .required('Password confirmation is required.')
    .when('password', ([password], schema) => {
      return schema.test({
        test: (password_confirmation) =>
          !!password && password_confirmation === password,
        message: 'Password confirmation must match the password.',
      })
    }),
})
